import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import useAlerts from '@/composables/useAlerts';
import { watch } from 'vue';

const { addAlert } = useAlerts();

const UNASSIGNED_SALESPEOPLE = gql`
  query UnassignedSalespeople {
    unassignedSalespeople {
      companies {
        NAME
        COMPANYID
        address {
          CITY
          STATE
        }
        phones {
          TYPEID
          NUMBERDISPLAY
        }
        OUTSIDESALES
        INSIDESALES
      }
      contacts {
        FIRSTNAME
        LASTNAME
        address {
          CITY
          STATE
        }
        INSIDESALES
        OUTSIDESALES
        COMPANYID
        CONTACTID
        phones {
          TYPEID
          NUMBERDISPLAY
        }
      }
    }
  }
`;

export default function useUnassignedSalespeople() {
  const { result, error, refetch, loading } = useQuery(UNASSIGNED_SALESPEOPLE, { fetchPolicy: 'no-cache' });

  watch(error, (newError) => {
    if (newError) {
      console.error(newError);
      addAlert('error', 'Error fetching unassigned salespeople');
    }
  });

  return {
    result,
    error,
    refetch,
    loading,
  };
}
